import { TabPanel, TabView, TabViewTabChangeEvent } from 'primereact/tabview';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import styles from './ComponentTabView.module.css';
import ComponentDetailsTab from './tabs/component-details-tab/ComponentDetailsTab';
import PcfTab from './tabs/pcf-tab/PcfTab';

const TABS = ['component-details', 'pcf'];

const ComponentTabView = () => {
  // Read params from URL
  const { componentId, footprintId } = useParams() as { componentId: string; footprintId: string };

  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  // Based on the URL parameters, the respective tab should be selected
  // Derive the active tab index fromthe URL
  const activeTabIndex = useMemo(() => {
    const pathSegments = location.pathname.split('/');
    const activeTab = pathSegments[pathSegments.length - 1];

    // If footprintId is present, we should always show the 'pcf' tab
    if (footprintId) {
      return TABS.indexOf('pcf');
    }

    const index = TABS.indexOf(activeTab);

    return Math.max(index, 0);
  }, [location.pathname]);

  const handleTabChange = (event: TabViewTabChangeEvent) => {
    const href = `/components/${componentId}/${TABS[event.index]}`;

    navigate(href);
  };

  return (
    <TabView
      className={styles['component-tab-view']}
      pt={{
        nav: { className: 'flex flex-row gap-6' },
      }}
      activeIndex={activeTabIndex}
      onTabChange={handleTabChange}
    >
      {/* Component Details Tab */}
      <TabPanel header={t('componentDetailsPage.tabs.componentDetailsTab.tabHeader')}>
        <ComponentDetailsTab />
      </TabPanel>

      {/* PCF Tab */}
      <TabPanel header={t('componentDetailsPage.tabs.pcfTab.tabHeader')}>
        <PcfTab />
      </TabPanel>
    </TabView>
  );
};

export default ComponentTabView;
